import {Controller, useForm} from "react-hook-form";
import {redirect, useActionData, useLoaderData, useNavigate, useSubmit} from "react-router-dom";
import jsonToFormData from "../../hooks/jsonToFormData";
import axios from "axios";
import {
    Alert,
    Box,
    Button,
    Container,
    Divider, FormControl,
    IconButton, InputLabel, MenuItem,
    Modal, /* Grid, */
    Paper, Select,
    Stack,
    Typography
} from "@mui/material";
import {CheckboxInput, DateTimePickerInput, TextFieldInput} from "../../components/forms/form";
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {Fragment, memo, useEffect, useMemo, useState} from "react";
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import EventNoteIcon from '@mui/icons-material/EventNote';
import {differenceInCalendarDays, format, isBefore, isEqual, isValid, parseISO} from "date-fns";
import Grid from '@mui/material/Unstable_Grid2';
import {ConditionsTable} from "./object/object_details";
import CloseIcon from '@mui/icons-material/Close';
import {showSnackbar} from "../../components/snackbarUtils";
import api from "../../hooks/useApi";
import PageTitle from "../../components/PageTitle";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';


export async function loader({request, params}) {
    const searchParam = (new URL(request.url)).searchParams;
    //console.log('Raw searchParams:', Array.from(searchParam.entries()));
    const searchParams = Array.from(searchParam.entries()).reduce((acc, [key, value]) => {
        if (acc[key]) {
            acc[key].push(value);
        } else {
            acc[key] = [value];
        }
        return acc;
    }, {});
    //console.log('Parsed searchParams:', searchParams);
    const defaultValues = {
        booking_from: searchParams.booking_from?.[0] || null,
        booking_to: searchParams.booking_to?.[0] || null,
        hotel: searchParams.parent || null,
        hotel_children: searchParams.selected || null,
    }

    const hotelObjName = searchParam.get('parent') ? 'parent'
        : searchParam.get('hotel_children')
            ? 'hotel_children'
            : null;
    const id = searchParam.get(hotelObjName);

    if (!id || !(defaultValues.booking_from && defaultValues.booking_to) || !(defaultValues.hotel ^ defaultValues.selected)) {
        //return redirect(searchParams.from?.[0] || '/', {replace: true})
    }

    const form = (await axios.get('/api/booking_modules/use/booking/form/get_form/')).data.forms;
    const modelDicts = {
        'hotel': 'HotelObj',
        'hotel_children': 'HotelObjChildren'
    }
    const infoAboutBook = await Promise.all(
        searchParam.getAll(hotelObjName).map(async (obj_index) => {
            const url = `/api/booking_modules/use/obj_details/${obj_index}/HotelObj/?${searchParam.toString()}`;
            const data = (await axios.get(url)).data;
            //console.log(data)
            if (data) {
                data.ctype = hotelObjName; // аккуратно дописываем ctype
            }
            return data;
        })
    );
    //console.log(infoAboutBook);

    //infoAboutBook.forEach(el => el.total_price = 100)
    let parentID = searchParam.get('parent');
    if (typeof parentID === 'string' && parentID.includes('=')) {
        const parts = parentID.split('=');
        parentID = parseInt(parts[1], 10); // Extract and parse the number
    }
    const parent_obj = (await axios.get(`/api/booking_modules/use/obj_details/${searchParam.get('parent')}/HotelObj/?${searchParam.toString()}`)).data;
    const selectedChildren = (searchParams.selected?.[0] || "").split(',').filter(Boolean);

    const childFlat1 = Array.isArray(infoAboutBook) ? infoAboutBook.flat() : [];

    const hotel_children_rules = childFlat1
        .flatMap(parent => [...(parent.hotel.matching_children || []), ...(parent.hotel.remaining_children || [])]) // берём matching + remaining вместе
        .filter(child => selectedChildren.includes(child.id?.toString())) // оставляем только выбранных
        .map(child => child.accommodation_conditions?.id) // берем id условий
        .filter(id => id !== undefined && id !== null); // убираем пустые

    defaultValues.hotel_children_rules = hotel_children_rules

// Считаем сумму только для выбранных детей (с учётом выбранных тарифов из URL)
    const childFlat = Array.isArray(parent_obj) ? parent_obj.flat() : [];

    // распарсим selectedRates формата "roomId:rateId,roomId2:rateId2"
    const selectedRatesRaw = searchParam.get('selectedRates') || '';
    const selectedRatesMap = selectedRatesRaw.split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .reduce((acc, pair) => {
            const [rid, rateId] = pair.split(':');
            if (rid && rateId) acc[String(rid)] = Number(rateId);
            return acc;
        }, {});

    const totalNEW = childFlat.reduce((acc, parent) => {
        const allChildren = [
            ...(parent.hotel.matching_children || []),
            ...(parent.hotel.remaining_children || []),
        ];

        allChildren.forEach((child) => {
            if (selectedChildren.includes(child.id.toString())) {
                const pickedRateId = selectedRatesMap[child.id];
                if (pickedRateId) {
                    const rate = (child.rates || []).find((r) => Number(r.id) === Number(pickedRateId));
                    if (rate) {
                        acc.total_price += Number(rate.total_price) || 0;
                        acc.total_tax += Number(rate.total_tax) || 0;
                        return;
                    }
                }
                // fallback, если тариф не найден — берём суммы с уровня номера
                acc.total_price += Number(child.total_price) || 0;
                acc.total_tax += Number(child.total_tax) || 0;
            }
        });
        return acc;
    }, {total_price: 0, total_tax: 0});

    // Потом вставляем в defaultValues (для отображения/отладки)
    defaultValues.price = `Ціна ${totalNEW.total_price} UAH, податок ${totalNEW.total_tax}`;
    return {form, searchParams, infoAboutBook, parent_obj, defaultValues};
}

export async function action({request, params}) {
    const formData = await request.formData();
    const query = new URL(request.url).searchParams;
    formData.set('adults', query.get('adults') || '1');
    formData.set('children', query.get('children') || '0');
    formData.set('rooms', query.get('rooms') || '1');
    formData.delete('children_ages');
    query.getAll('children_ages').forEach((age) => {
        formData.append('children_ages', age);
    });
    //console.log(formData);
    //return null;
    const actionData = {};
    try {
        const response = await api.post('/api/booking_modules/use/booking/form/', formData);

        // Сохранение токенов аутентификации
        if (response.data.tokens) {
            await localStorage.setItem('access_token', response.data.tokens.access);
            await localStorage.setItem('refresh_token', response.data.tokens.refresh);
            api.defaults.headers.common['Authorization'] = `Bearer ${response.data.tokens.access}`;
        }

        // Сохранение бронирования в localStorage
        let currentBooks = JSON.parse(localStorage.getItem('user_bookings') || '[]');
        currentBooks = [...currentBooks, response.data.data.id];
        localStorage.setItem('user_bookings', JSON.stringify(currentBooks));

        actionData.successfulID = response.data.data.id;

        await new Promise(resolve => setTimeout(resolve, 100)); // Даем браузеру время на обновление токена
        window.location.reload();
        window.location.href = `/book-details/${response.data.data.id}`;

    } catch (e) {
        if (e.response?.status === 401) {
            const newAccessToken = await refreshToken();
            if (newAccessToken) {
                return await api.post('/api/booking_modules/use/booking/form/', formData);
            }
        }
        actionData.error = e;
    }

    return actionData;
}

async function refreshToken() {
    try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) throw new Error('No refresh token found');

        const response = await axios.post('/api/token/refresh/', {refresh: refreshToken});

        // Обновляем токены
        localStorage.setItem('access_token', response.data.access);
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;

        return response.data.access;
    } catch (error) {
        console.error('Ошибка обновления токена', error);
        return null;
    }
}

export default function BookingForm() {
    const {searchParams, parent_obj, infoAboutBook, defaultValues} = useLoaderData();
    //console.log('searchParams:', searchParams);
    const actionData = useActionData();
    const navigate = useNavigate();
    useEffect(() => {
        // Проверяем, есть ли хотя бы один объект с booking: "yes"
        if (Array.isArray(infoAboutBook) && infoAboutBook.some(item => item.booking === "yes")) {
            showSnackbar("Помилка запиту: Об'єкт вже заброньовано на ці дати!", "error", {
                sx: {backgroundColor: "#ff0000", color: "white"},
            });
            navigate("/"); // Редирект на главную
        }
    }, [infoAboutBook, navigate]);

    useEffect(() => {
        if (searchParams.booking_from?.[0] || searchParams.booking_to?.[0]) {

            const now = new Date();
            const bookingFromDate = parseISO(searchParams.booking_from?.[0]);
            const bookingToDate = parseISO(searchParams.booking_to?.[0]);
            bookingFromDate.setHours(0, 0, 0, 0);
            bookingToDate.setHours(0, 0, 0, 0);
            now.setHours(0, 0, 0, 0);

            if (isBefore(bookingFromDate, now) && !isEqual(bookingFromDate, now)) {
                showSnackbar("Помилка запиту: Дата бронювання у минулому!", "error", {
                    sx: {backgroundColor: "#ff0000", color: "white"},
                });
                navigate("/"); // Редирект на главную
            } else if (isBefore(bookingFromDate, now)) {
                showSnackbar("Помилка запиту: Дата бронювання у минулому!", "error", {
                    sx: {backgroundColor: "#ff0000", color: "white"},
                });
                navigate("/"); // Редирект на главную
            } else if (isBefore(bookingToDate, bookingFromDate)) {
                showSnackbar("Помилка запиту: Дата виїзду не може бути раніше дати заїзду!", "error", {
                    sx: {backgroundColor: "#ff0000", color: "white"},
                });
                navigate("/"); // Редирект на главную
            }
        }
    }, [searchParams.booking_from?.[0], searchParams.booking_to?.[0], navigate]);

    const formHook = useForm({defaultValues: {...defaultValues}});
    const submit = useSubmit();
    const handleFormSubmit = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            method: 'post'
        })
    }

    const TIME_ARRIVED = [
        '00-00', '01-00', '02-00', '03-00', '04-00', '05-00', '06-00', '07-00', '08-00', '09-00',
        '10-00', '11-00', '12-00', '13-00', '14-00', '15-00', '16-00', '17-00', '18-00', '19-00',
        '20-00', '21-00', '22-00', '23-00'
    ];

    const checkInfo = formHook.watch('check_info');

    return (
        <>
            <PageTitle title="Оформлення бронювання"/>
            <Container maxWidth='lg' sx={{mb: 10}}>
                <Box
                    sx={{
                        my: 2,
                        mb: 3,
                        width: '100%',
                        position: 'relative',
                    }}
                >
                    {/* Кнопка только на мобилке */}
                    <Button
                        variant="text"
                        onClick={() => navigate('/')}
                        sx={{
                            display: {xs: 'flex', md: 'none'},
                            alignItems: 'center',
                            gap: 0.5,
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.9rem',

                            position: 'absolute',
                            top: 0,
                            left: 0,

                            px: 1.5,
                            py: 0.7,

                            borderRadius: 3,

                            backgroundColor: '#f5f7ff',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.08)',

                            '&:hover': {
                                backgroundColor: '#eef2ff',
                            },
                        }}
                    >
                        ← На головну
                    </Button>

                    {/* Заголовок */}
                    <Box sx={{textAlign: 'center'}}>
                        <Typography
                            variant='h5'
                            fontWeight='bold'
                            sx={{mb: 0.5}}
                        >
                            Бронювання
                        </Typography>

                        <Typography
                            variant='h6'
                            sx={{
                                fontWeight: 500,
                            }}
                        >
                            Перевірте інформацію та заповніть свої дані
                        </Typography>

                        {/* декоративная полоска */}
                        <Box
                            sx={{
                                display: {xs: 'block', md: 'none'},
                                width: 40,
                                height: 4,
                                borderRadius: 999,
                                backgroundColor: 'primary.main',
                                mx: 'auto',
                                mt: 1.5,
                            }}
                        />
                    </Box>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="uk">
                    <form
                        noValidate
                        method="post"
                        action="/api/booking_modules/use/booking/form/"
                        onSubmit={formHook.handleSubmit(handleFormSubmit)}
                    >
                        <Grid container justifyContent='space-around'>
                            <Grid order={{md: 0, xs: 1}} container component={Paper}
                                  sx={{p: 2, height: 'fit-content',/* mt: { xs: 2, md: 0 }  */}} xs={12} md={8}>
                                <Grid xs={12} sx={{mb: 2,}}>
                                    <Typography variant='h6' sx={{fontWeight: 'bold'}}>Ваші дані</Typography>
                                </Grid>
                                <Grid container xs={12} spacing={2}>
                                    <Grid sm={6} xs={12}>
                                        <TextFieldInput name='first_name' props={{
                                            required: true,
                                            type: 'TextInput',
                                            label: "Ім'я",
                                            max_length: 15,
                                            initial: '',
                                        }} hook={formHook}/>
                                    </Grid>
                                    <Grid sm={6} xs={12}>
                                        <TextFieldInput name='last_name' props={{
                                            required: true,
                                            type: 'TextInput',
                                            label: "Прізвище",
                                            max_length: 20,
                                            initial: '',
                                        }} hook={formHook}/>
                                    </Grid>
                                    <Grid sm={6} xs={12}>
                                        <TextFieldInput name='phone' props={{
                                            required: true,
                                            type: 'TextInput',
                                            label: "Телефон",
                                            max_length: 15,
                                            initial: '',
                                        }} hook={formHook}/>
                                    </Grid>
                                    <Grid sm={6} xs={12} style={{display: 'none'}}>
                                        <TextFieldInput name='status' props={{
                                            required: false,
                                            type: 'TextInput',
                                            label: "status",
                                            max_length: 15,
                                            initial: '4',
                                        }} hook={formHook}/>
                                    </Grid>
                                    <Grid sm={6} xs={12} style={{display: 'none'}}>
                                        <TextFieldInput name='hotel_children_rules' props={{
                                            required: false,
                                            type: 'TextInput',
                                            label: "hotel_children_rules",
                                            max_length: 15,
                                            initial: (defaultValues.hotel_children_rules || []).join(','),
                                        }} hook={formHook}/>
                                    </Grid>
                                    <Grid sm={6} xs={12}>
                                        <TextFieldInput name='email' props={{
                                            required: true,
                                            type: 'EmailInput',
                                            label: "Пошта",
                                            max_length: 50,
                                            initial: '',
                                        }} hook={formHook}/>
                                    </Grid>
                                    <Grid sm={6} xs={12}>
                                        <Controller
                                            name="time_arrived"
                                            control={formHook.control}
                                            defaultValue=""
                                            rules={{required: "Оберіть приблизний час прибуття"}}
                                            render={({field}) => (
                                                <FormControl fullWidth
                                                             error={!!formHook.formState.errors?.time_arrived}>
                                                    <InputLabel id="time-arrived-label">Приблизний час
                                                        прибуття</InputLabel>
                                                    <Select
                                                        {...field}
                                                        labelId="time-arrived-label"
                                                        label="Приблизний час прибуття"
                                                    >
                                                        {TIME_ARRIVED.map((time) => (
                                                            <MenuItem key={time} value={time}>
                                                                {time}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formHook.formState.errors?.time_arrived && (
                                                        <Typography variant="caption"
                                                                    sx={{color: 'error.main', mt: 0.5}}>
                                                            {String(formHook.formState.errors.time_arrived.message || '')}
                                                        </Typography>
                                                    )}
                                                </FormControl>
                                            )}
                                        />
                                    </Grid>
                                    <Grid xs={12}>
                                        <TextFieldInput name='comments' props={{
                                            required: false,
                                            type: 'TextInput',
                                            label: "Коментар",
                                            max_length: 300,
                                            initial: '',
                                        }} hook={formHook}/>
                                    </Grid>
                                    <Grid xs={12}>
                                        <CheckboxInput
                                            name='check_info'
                                            props={{
                                                label: "Погоджуюсь на використання особистої інформації та ознайомлений(-а) з усіма правила додатку.",
                                                required: true,
                                                initial: false,
                                                type: "CheckboxInput",
                                                widget_attrs: {}
                                            }}
                                            hook={formHook}
                                            handleVisibleFields={() => {
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                {actionData?.error && (<Grid xs={12}>
                                    <Alert severity='error'>
                                        {JSON.stringify(actionData.error.response.data)}
                                    </Alert>
                                </Grid>)}
                                <Grid xs={12} sx={{mt: 2}}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        fullWidth
                                        disabled={!checkInfo}
                                    >
                                        Забронювати
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid order={{md: 1, xs: 0}} container component={Paper} sx={{p: 2}} xs={12} md={3}>
                                <CheckoutCheckComponent
                                    data={{parent: parent_obj, child: infoAboutBook, searchParams: searchParams}}
                                    timeArrive={formHook.getValues('time_arrived')} hook={formHook}/>
                            </Grid>
                        </Grid>
                    </form>
                </LocalizationProvider>
                <Box>{/*JSON.stringify(infoAboutBook)*/}</Box>
            </Container>
        </>
    )
}
const CheckoutCheckComponent = ({data, timeArrive, hook}) => {

    async function fetchRulesById(id) {
        if (!id) return null;
        try {
            const {data} = await axios.get(`/api/booking_modules/use/rules/${id}/`);
            return data; // объект условий
        } catch {
            return null;
        }
    }

    async function resolveConditions(child, selectedRatesMap) {
        // 1️⃣ Если уже объект — возвращаем сразу
        if (child?.accommodation_conditions && !Array.isArray(child.accommodation_conditions)) {
            return child.accommodation_conditions;
        }

        // 2️⃣ Пробуем выбранный тариф
        const pickedRateId = selectedRatesMap?.[child?.id];
        if (pickedRateId) {
            const rate = (child?.rates || []).find(r => Number(r.id) === Number(pickedRateId));
            if (rate?.rates_rules) {
                const fromRate = await fetchRulesById(rate.rates_rules);
                if (fromRate) return fromRate;
            }
        }

        // 3️⃣ fallback: по child.rules
        const ruleId = Array.isArray(child?.rules) && child.rules.length ? child.rules[0] : null;
        if (ruleId) {
            const fromChild = await fetchRulesById(ruleId);
            if (fromChild) return fromChild;
        }

        // 4️⃣ если ничего нет
        return null;
    }

// ====== ИЗМЕНИТЬ state ======
    const [modalCfg, setModalCfg] = useState({
        open: false,
        child: null,
        conditions: null,
        loading: false,
        error: null
    });

// ====== ДОБАВИТЬ ФУНКЦИЮ ОТКРЫТИЯ МОДАЛКИ ======
    async function openConditions(child) {
        setModalCfg({open: true, child, conditions: null, loading: true, error: null});
        try {
            const cond = await resolveConditions(child, selectedRatesMap);
            setModalCfg(prev => ({...prev, conditions: cond, loading: false}));
        } catch (e) {
            setModalCfg(prev => ({...prev, loading: false, error: 'Не вдалося завантажити умови'}));
        }
    }

    const {parent, child, searchParams} = data;

    const childFlat = Array.isArray(child) ? child.flat() : [];

    //const [modalCfg, setModalCfg] = useState({open: false, child: null});

    const parsedTimes = useMemo(() => {
        const start_time = parseISO(searchParams.booking_from?.[0] || '');
        const end_time = parseISO(searchParams.booking_to?.[0] || '');

        return {
            start_time,
            end_time,
            start_time_f: start_time ? format(start_time, 'dd.MM.yyyy') : 'Невідомо',
            end_time_f: end_time ? format(end_time, 'dd.MM.yyyy') : 'Невідомо',
            departure_f: end_time ? format(end_time, 'dd.MM.yyyy 11:00') : 'Невідомо',
        };
    }, [searchParams]);

    const [openModalConditions, setOpenModalConditions] = useState(false);

    const numNights = parsedTimes.start_time && parsedTimes.end_time
        ? differenceInCalendarDays(parsedTimes.end_time, parsedTimes.start_time)
        : 0;

    // распарсим мапу выбранных тарифов из URL
    const selectedRatesMap = useMemo(() => {
        const raw = searchParams.selectedRates?.[0] || '';
        return raw.split(',')
            .map((s) => s.trim())
            .filter(Boolean)
            .reduce((acc, pair) => {
                const [rid, rateId] = pair.split(':');
                if (rid && rateId) acc[String(rid)] = Number(rateId);
                return acc;
            }, {});
    }, [searchParams.selectedRates?.[0]]);

    // посчитаем суммы с учётом выбранных тарифов
    const totals = useMemo(() => {
        // соберём все выбранные child-объекты
        const selectedIds = (searchParams.selected?.[0] || '').split(',').filter(Boolean);
        const selectedChildrenList = childFlat.flatMap((hotelObj) => (
            [
                ...(hotelObj.hotel.matching_children || []),
                ...(hotelObj.hotel.remaining_children || []),
            ].filter((ch) => selectedIds.includes(String(ch.id)))
        ));

        return selectedChildrenList.reduce((acc, child) => {
            const pickedRateId = selectedRatesMap[child.id];
            if (pickedRateId) {
                const rate = (child.rates || []).find((r) => Number(r.id) === Number(pickedRateId));
                if (rate) {
                    acc.total_price += Number(rate.total_price) || 0;
                    acc.total_tax += Number(rate.total_tax) || 0;
                    return acc;
                }
            }
            acc.total_price += Number(child.total_price) || 0;
            acc.total_tax += Number(child.total_tax) || 0;
            return acc;
        }, {total_price: 0, total_tax: 0});
    }, [childFlat, searchParams.selected?.[0], selectedRatesMap]);

    return (
        <Stack direction="column" spacing={2}>
            {/* Название объекта */}
            <BoldHeadingTypo>
                {parent?.[0]?.hotel.name || 'Назва обʼєкта'}
            </BoldHeadingTypo>

            {/* Локация */}
            {parent?.[0]?.hotel?.location?.city?.city && (
                <Typography sx={{alignItems: 'center', display: 'flex', mt: 2}}>
                    <PlaceOutlinedIcon sx={{color: 'blue'}} fontSize="large"/>
                    {parent[0].hotel.location.city.city}, {parent[0].hotel.location.text_address}
                </Typography>
            )}

            <Divider/>

            {/* Названия выбранных номеров */}
            {childFlat.map((hotelObj) => (
                [...(hotelObj.hotel.matching_children || []), ...(hotelObj.hotel.remaining_children || [])] // объединяем matching и remaining
                    .filter(child => {
                        const selectedIds = searchParams.selected?.[0]?.split(',') || [];
                        return selectedIds.includes(String(child.id));
                    })
                    .map((child, index) => (
                        <Box key={`${child.id}-${index}`}>
                            <Typography>номер</Typography>
                            <Typography sx={{fontWeight: 'bold'}}>
                                {child.name}
                            </Typography>
                            <Typography>
                                {child.classification.name}
                            </Typography>
                        </Box>
                    ))
            ))}

            <Divider/>

            {/* Стоимость */}
            <BoldHeadingTypo>Вартість</BoldHeadingTypo>
            <BoldHeadingTypo variant="h6">{totals.total_price} UAH</BoldHeadingTypo>
            <Typography>+ податки та збори - {totals.total_tax} UAH</Typography>

            <Divider/>

            {/* Деталі бронювання */}
            <BoldHeadingTypo>Деталі бронювання</BoldHeadingTypo>
            <Box sx={{width: '100%'}}>
                <Typography>Початок бронювання</Typography>
                <Typography sx={{fontWeight: 'bold'}}>{parsedTimes.start_time_f}</Typography>

                <Typography sx={{alignItems: 'center', display: 'flex'}}>
                    <ExitToAppIcon/><span>Заїзд</span>
                </Typography>
                <IsolatedDateTimeTypo sx={{fontWeight: 'bold'}} hook={hook} name="time_arrived"/>

                <Typography sx={{alignItems: 'center', display: 'flex'}}>
                    <ExitToAppIcon/><span>Виїзд</span>
                </Typography>
                <Typography sx={{fontWeight: 'bold'}}>{parsedTimes.departure_f}</Typography>
            </Box>

            <Typography sx={{alignItems: 'center', display: 'flex'}}>
                <EventNoteIcon/><span>Тривалість проживання</span>
            </Typography>
            <Typography sx={{fontWeight: 'bold'}}>
                {numNights + 1} днів ({numNights} ночей)
            </Typography>

            <Divider/>

            {/* Кровати */}
            <BoldHeadingTypo>Ліжка</BoldHeadingTypo>
            {childFlat.flatMap((hotelObj) =>
                [...(hotelObj.hotel.matching_children || []), ...(hotelObj.hotel.remaining_children || [])]
                    .filter(child => {
                        const selectedIds = searchParams.selected?.[0]?.split(',') || [];
                        return selectedIds.includes(String(child.id));
                    })
            ).flatMap((child) =>
                (child.bedrooms || []).flatMap((bedroom, index) => {
                    const beds = [];

                    // Перебираем все типы кроватей
                    const bedTypes = [
                        {count: bedroom.number_of_beds_type_single, label: 'Односпальне ліжко'},
                        {count: bedroom.number_of_beds_type_double, label: 'Двоспальне ліжко'},
                        {count: bedroom.number_of_beds_type_king, label: 'Кінг-сайз ліжко'},
                        {count: bedroom.number_of_beds_type_super_king, label: 'Супер кінг-сайз ліжко'},
                        {count: bedroom.number_of_beds_type_bunk, label: 'Двоповерхове ліжко'},
                        {count: bedroom.number_of_beds_type_sofa_bed, label: 'Диван-ліжко'},
                        {count: bedroom.number_of_beds_type_futon, label: 'Футон'},
                    ];

                    // Добавляем в список только ненулевые кровати
                    bedTypes.forEach(({count, label}) => {
                        if (Number(count) > 0) {
                            beds.push(
                                <Typography key={`${child.id}-${index}-${label}`}>
                                    {label}: {count} спальних місць
                                </Typography>
                            );
                        }
                    });

                    return beds;
                })
            )}


            <Typography>
                {searchParams.adults?.[0]} дорослих
                {searchParams.children?.[0] && `, ${searchParams.children[0]} дітей`}
                {searchParams.rooms?.[0] && `, ${searchParams.rooms[0]} номерів`}
            </Typography>

            <Divider/>

            {/* Умови відміни */}
            <BoldHeadingTypo>Передплата та скасування</BoldHeadingTypo>
            {childFlat
                .flatMap((hotelObj) => [...(hotelObj.hotel.matching_children || []), ...(hotelObj.hotel.remaining_children || [])])
                .filter(child => {
                    const selectedIds = searchParams.selected?.[0]?.split(',') || [];
                    return selectedIds.includes(String(child.id));
                })
                .map((child, index) => (
                    <Box key={index} sx={{mb: 2}}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => openConditions(child)}
                        >
                            <Typography>
                                Інформація про передплату та скасування — {child.name}
                            </Typography>
                        </Button>
                    </Box>
                ))}

            <Modal open={!!modalCfg?.open} onClose={() => setModalCfg({open: false, child: null})}>
                <Container maxWidth="md"
                           sx={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Paper
                        sx={{padding: '20px', maxHeight: '90vh', minHeight: '50vh', width: '100%', overflow: 'auto'}}>
                        <Box className="flex stickSides">
                            <Box>
                                <BoldHeadingTypo>
                                    Інформація про передплату і скасування — {modalCfg.child?.name}
                                </BoldHeadingTypo>
                            </Box>
                            <Box className="flex" alignItems="center">
                                <IconButton onClick={() => setModalCfg({open: false, child: null})}>
                                    <CloseIcon/>
                                </IconButton>
                            </Box>
                        </Box>

                        <Divider sx={{my: 2}}/>

                        {modalCfg.loading && <Typography>Завантаження умов…</Typography>}
                        {modalCfg.error && <Alert severity="error">{modalCfg.error}</Alert>}
                        {!modalCfg.loading && !modalCfg.error && (
                            modalCfg.conditions
                                ? <ConditionsTable conditions={modalCfg.conditions}/>
                                : <Typography>Умови не вказані</Typography>
                        )}
                    </Paper>
                </Container>
            </Modal>

        </Stack>
    );
};

export const BoldHeadingTypo = memo(({variant = 'h5', sx, children}) => {
    return <Typography variant={variant} sx={{fontWeight: 'bold', ...sx}}>{children}</Typography>
})

const IsolatedDateTimeTypo = ({hook, name, sx}) => {
    const rawDate = hook.getValues(name);
    const date = rawDate ? parseISO(rawDate) : null;
    const valid = isValid(date);

    return (
        <Typography sx={sx}>
            {valid ? format(date, 'dd.MM.yyyy HH:mm') : 'Оберіть час заїзду'}
        </Typography>
    );
};
